/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import chart from 'shared/ui/components/charts/chart';
import Badge from 'shared/ui/components/Badge.vue';

const __vue_script__ = {
    name: 'Activity',

    components: { Badge },

    mixins: [chart], // not needed except for tight coupling between tabs and charts

    data() {
        return {
            ready: false,
            stats: [],
        };
    },

    methods: {
        async initChart() {
            const t = d => this.$t(`analytics.charts.active_users.${d}`);

            const data = await this.getData();

            this.stats = [
                {
                    class: 'created-users',
                    count: data.created_users,
                    label: t('total_users'),
                },
                {
                    class: 'activated-users',
                    count: data.activated_users,
                    label: t('activated'),
                    details: {
                        pc: this.getPercentage(data.created_users, data.activated_users),
                        label: t('of_total_users'),
                    },
                },
                {
                    class: 'active-users',
                    count: data.active_users_last_day,
                    label: t('active_today'),
                    details: {
                        pc: this.getPercentage(data.activated_users, data.active_users_last_day),
                        label: t('of_activated'),
                    },
                },
                {
                    class: 'active-users',
                    count: data.active_users_last_hour,
                    label: t('active_last_hour'),
                    details: {
                        pc: this.getPercentage(data.activated_users, data.active_users_last_hour),
                        label: t('of_activated'),
                    },
                },
            ];

            this.ready = true;
        },

        async getData() {
            return this.$services.analytics.loadActivityData(this.eventId);
        },

        getPercentage(prev, next) {
            if (!prev || !next) { return '0%'; }
            return Math.round(100 / (prev / next)) + '%';
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity chart-widget"},[_c('div',{staticClass:"title"},[(_vm.icon)?_c('i',{class:("ic-" + _vm.icon)}):_vm._e(),_vm._v(_vm._s(_vm.$t("analytics.charts.active_users.title")))]),(_vm.ready)?_c('div',{staticClass:"metrics"},_vm._l((_vm.stats),function(d){return _c('div',{staticClass:"card",class:d.class},[_c('div',{staticClass:"count"},[_vm._v(_vm._s(d.count))]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(d.label))]),(d.details)?_c('div',{staticClass:"details"},[_c('badge',{staticClass:"percent"},[_vm._v(_vm._s(d.details.pc))]),_c('span',{staticClass:"percent-label"},[_vm._v(_vm._s(d.details.label))])],1):_vm._e()])}),0):_vm._e(),_c('div',{staticClass:"details"},[_vm._t("details")],2)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Activity.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__